import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";

@Injectable()
export class CommandColumnService extends CommandAction {

    public execute(parent: WidgetsAbstract, widget: WidgetsAbstract): WidgetsColumnModel {
        const newColumn = new WidgetsColumnModel();
        newColumn.parentId =  parent.id;
        return newColumn;              
    }
}
